export default function deleteTimeplanUnit(
  timeplanUnits,
  removedTPU,
  removeMileageAllowance = false,
) {
  if (!removeMileageAllowance) {
    return timeplanUnits.filter(tpu => tpu.id !== removedTPU.id);
  }
  return timeplanUnits
    .filter(tpu => tpu.id !== removedTPU.id)
    .filter(tpu => !(tpu.has('kilometers') && tpu.date === removedTPU.date));
}
